import React, { useEffect, useState } from "react";
import axios from "../../../utils/axios";
import { message, Spin } from "antd";

import EducationAttendanceLogs from "../education/educationAttedLogs";
// later
// import QSRLogs from "./qsr/qsrAttendanceLogs";

const AttendanceLogs = () => {

  const organizationId = localStorage.getItem("organizationId");
  const projectname = localStorage.getItem("selectedProject");
  const user = JSON.parse(localStorage.getItem('user'));
  const [sector, setSector] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dashboardConfig, setDashboardConfig] = useState(null)

  const getProjectDetails = async () => {
    try {

      setLoading(true);

      const res = await axios.post("/get-project-details", {
        projectName: projectname,
        organizationId
      });

      if (res?.data?.project?.mainCategory) {
        setSector(res.data.project.mainCategory);
      }

    } catch (err) {

      if (err.response?.data?.msg) {
        message.error(err.response.data.msg);
      } else if (err.response?.data) {
        message.error(err.response.data);
      } else if (err.response?.data?.userName?.[0]) {
        message.error(err.response.data.userName[0]);
      } else if (err.response?.status === 401) {
        message.error("Unauthorized. Please login again.");
      } else {
        message.error("Something went wrong");
      }

    } finally {
      setLoading(false);
    }

  };
   const fetchDashboardConfig = async () => {
    try {
      const res = await axios.post('/fetch-dashboard-settings', {
        organizationId,
        username: user?.username,
        projectname
      });

      if (res.data?.success) {
        setDashboardConfig(res.data.data.pages?.["attendance-logs"]);
      }
    } catch (err) {
      console.error("Dashboard config fetch failed", err);
    }
  };

  useEffect(() => {
    getProjectDetails();
    fetchDashboardConfig()
  }, [projectname]);

  /* ---------------- SECTOR ROUTER ---------------- */

  const PageRouter = () => {

    switch (sector) {

      case "Education":
        return <EducationAttendanceLogs config={dashboardConfig}/>;

      case "QSR / Fast Food":
        return <div>QSR Logs</div>;

      case "Manufacturing":
        return <div>Manufacturing Logs</div>;

      default:
        return <div>No attendance logs available</div>;

    }

  };

  if (loading) return <Spin />;

  return (
  <div className="min-h-screen max-w-7xl mx-auto">

    {/* PAGE HEADER */}
    <div className="mb-8">
      <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
        Attendance Logs
      </h1>

      <p className="text-gray-500 mt-1">
        Staff entry and exit activity monitoring
      </p>
    </div>

    {/* SECTOR PAGE */}
    <PageRouter />

  </div>
);

};

export default AttendanceLogs;